import { createSelector } from '@ngrx/store';
import { getLoginState } from './login.reducer';

export const getLoggingIn = createSelector(getLoginState, state => state && state.loggingIn);
export const getLoginError = createSelector(getLoginState, state => state && state.error);
export const getLoginParams = createSelector(getLoginState, state => state && state.loginParams);
